// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar-module--Toolbar--1N35q","Logo":"Toolbar-module--Logo--1wssI","DesktopOnly":"Toolbar-module--DesktopOnly--thiLU"};